import React, { ReactElement } from 'react';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as TI403Icon } from './icons/TimeIntelligence_403_Icon.svg';
import { useGoToHome } from './hooks/useGoToHome';
import { useErrorPageStyles } from './hooks/useErrorPageStyles';
import ZeroTime_Logo_Error_Pages from './logo/ZeroTime_Logo_Error_Pages.svg';

const ErrorPage_403 = (): ReactElement => {
  const classes = useErrorPageStyles();
  const { goToHome } = useGoToHome();

  return (
    <div data-testid="error-page-403" className={classes.root}>
      <img src={ZeroTime_Logo_Error_Pages} alt="Zt Logo" />
      <TI403Icon className={classes.icon} />
      <Typography variant="h2" className={classes.titleText}>
        <FormattedMessage id="errorPage._403.title" />
      </Typography>
      <Typography variant="h6" className={classes.subTitleText}>
        <FormattedMessage id="errorPage._403.subText" />
      </Typography>
      <Button
        className={classes.button}
        color="primary"
        variant="contained"
        onClick={goToHome}
        size="large"
      >
        <FormattedMessage id="errorPage._403.buttonText" />
      </Button>
    </div>
  );
};

export default ErrorPage_403;
